import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelRadio as _vModelRadio, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-container" }
const _hoisted_4 = { class: "modal-body" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "floorplanFilterPanel" }
const _hoisted_7 = { class: "filterElem" }
const _hoisted_8 = { class: "filterElem" }
const _hoisted_9 = { class: "filterElem" }
const _hoisted_10 = { class: "filterElem" }
const _hoisted_11 = { class: "filterElem" }
const _hoisted_12 = { class: "filterElem" }
const _hoisted_13 = { class: "statusFilterPanel" }
const _hoisted_14 = { class: "filterElem" }
const _hoisted_15 = { class: "filterElem" }
const _hoisted_16 = { class: "filterElem" }
const _hoisted_17 = { class: "filterElem" }

import { appStore } from "@/stores/app-store";
import { ref, watch } from "vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'FilterModal',
  props: {
  show: Boolean
},
  emits: ['close','filter'],
  setup(__props, { emit: __emit }) {

const props = __props;

// eslint-disable-next-line
const emit = __emit

const store = appStore();
let floorplan = ref(store.floorplanFilter);
let status = ref(store.statusFilter);
let availableSizes = new Set<number>();
let availablePrices = new Set<number>();

store.unitsData.forEach(element => {
  availableSizes.add(element.minSqft);
  availableSizes.add(element.maxSqft);
  availablePrices.add(element.startingPrice);
});

let priceArray: number[] = Array.from(availablePrices.values());
priceArray.sort();

let sizesArray: number[] = Array.from(availableSizes.values());
sizesArray.sort();

function applyFilter(){
  store.floorplanFilter = floorplan.value;
  store.statusFilter = status.value;

  emit('close');
  emit('filter');
}
function resetFilter(){
  floorplan.value = '';
  emit('close');
}

watch(
  () => store.floorplanFilter,
  (newVal, oldVal) => {
    floorplan.value = newVal;
  }
)
watch(
  () => store.statusFilter,
  (newVal, oldVal) => {
    status.value = newVal;
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (__props.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _cache[22] || (_cache[22] = _createElementVNode("div", { class: "modal-header" }, null, -1)),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "filterElem" }, "FILTER BY FLOORPLAN:", -1)),
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "showAll",
                          value: "",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[10] || (_cache[10] = _createElementVNode("label", { for: "showAll" }, "SHOW ALL", -1))
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "theAustin",
                          value: "The Austin",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("label", { for: "theAustin" }, "THE AUSTIN", -1))
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "theBrookline",
                          value: "The Brookline",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("label", { for: "theBrookline" }, "THE BROOKLINE", -1))
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "theCarmel",
                          value: "The Carmel",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[13] || (_cache[13] = _createElementVNode("label", { for: "theCarmel" }, "THE CARMEL", -1))
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "theDurham",
                          value: "The Durham",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("label", { for: "theDurham" }, "THE DURHAM", -1))
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "theEvanston",
                          value: "The Evanston",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(floorplan) ? (floorplan).value = $event : floorplan = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(floorplan)]
                        ]),
                        _cache[15] || (_cache[15] = _createElementVNode("label", { for: "theEvanston" }, "THE EVANSTON", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "filterElem" }, "FILTER BY STATUS:", -1)),
                      _createElementVNode("div", _hoisted_14, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "all",
                          value: "",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(status)]
                        ]),
                        _cache[17] || (_cache[17] = _createElementVNode("label", { for: "all" }, "ALL", -1))
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "available",
                          value: "Available",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(status)]
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("label", { for: "available" }, "AVAILABLE", -1))
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "comingSoon",
                          value: "ComingSoon",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(status)]
                        ]),
                        _cache[19] || (_cache[19] = _createElementVNode("label", { for: "comingSoon" }, "COMING SOON", -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          id: "sold",
                          value: "Sold",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(status) ? (status).value = $event : status = $event))
                        }, null, 512), [
                          [_vModelRadio, _unref(status)]
                        ]),
                        _cache[20] || (_cache[20] = _createElementVNode("label", { for: "sold" }, "SOLD", -1))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", { class: "buttonPanel" }, [
                    _createElementVNode("button", {
                      class: "formButton",
                      onClick: applyFilter
                    }, "APPLY"),
                    _createElementVNode("button", {
                      class: "formButton",
                      onClick: resetFilter
                    }, "CANCEL")
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})